import React, { useEffect, useState } from 'react';
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';
import { MediaItemValue } from '@fulcrumapp/fulcrum-core';
import MediaThumbnail from './media-thumbnail';
import { useApp } from '../../../hooks/use-app';

type Props = {
  item: MediaItemValue;
  styles: React.CSSProperties;
  handleClick: (e: React.MouseEvent<HTMLDivElement>) => void;
};

// @deprecated We should work on consolidating thumbnails
const PhotoThumbnail = ({ item, styles, handleClick }: Props) => {
  const app = useApp();
  const [isPanorama, setIsPanorama] = useState(false);

  useEffect(() => {
    const isPhotoPanorama = (itemMediaID: string) => {
      app.dataSource.source.getPhoto(itemMediaID, (err, object) => {
        let imageHeight: number;
        let imageWidth: number;
        if (err) {
          imageHeight = NaN;
          imageWidth = NaN;
        } else {
          imageHeight = Number(object.exif?.pixel_y_dimension);
          imageWidth = Number(object.exif?.pixel_x_dimension);
        }

        setIsPanorama(imageHeight * 2 === imageWidth);
      });
    };
    isPhotoPanorama(item.mediaID);
  }, [app, item]);

  return (
    <MediaThumbnail
      styles={styles}
      item={item}
      handleClick={handleClick}
      data-testid="photo-thumbnail"
    >
      { isPanorama ? (
        <ThreeSixtyIcon
          sx={{
            position: 'absolute',
            top: '65%',
            left: '7%',
            color: '#fff',
          }}
          data-testid="360-icon"
        />
      )
        : <></>}
    </MediaThumbnail>
  );
};

export default PhotoThumbnail;
